export default "__VITE_ASSET__c00ac3f3__"